import { useLocalImage } from "../../../utility/useLocalIMage";
import React from "react";

const SelectBGWrapper = ({ children, type, shift, hideControls = false }) => {
    const { saveImage, clearImage, image } = useLocalImage(`img-${type}-${shift}`);

    // Inject props into every child
    const enhancedChildren = React.Children.map(children, (child) =>
        React.cloneElement(child, {
            image: image
        })
    );

    return (
        <div>
            {!hideControls && <div className="d-flex w-100">
                <input
                    type="file"
                    className="form-control w-25 ms-3 h-100"
                    onChange={(e) => saveImage(e.target.files[0])}
                />

                <button className="btn btn-danger mb-4 ms-3" onClick={clearImage}>
                    Reset
                </button>
            </div>}

            {enhancedChildren}
        </div>
    );
};

export default SelectBGWrapper;
